import PropTypes from "prop-types"
import React from "react"

import { useTranslate } from "context/translateContext"
import { getCurrencyLocaleValue } from "data/utils/formaters"

import gridStyles from "../../../components/Plans.module.css"

const DiscountItem = ({
  currency,
  isFree,
  lang,
  priceToPay,
  priceBeforeDiscount,
}) => {
  const { t: translate } = useTranslate()

  const formatPrice = price =>
    getCurrencyLocaleValue({
      value: price,
      currency,
      language: lang,
      fractionDigits: price % 1 !== 0 ? 2 : 0,
    })

  return (
    <p className={`${gridStyles.mainPricingCurrency}`}>
      <span className="c-red textLineThrough">
        {formatPrice(priceBeforeDiscount)}
      </span>
      <span className="c-black">
        {" "}
        {isFree ? translate("for FREE") : formatPrice(priceToPay)}
      </span>
    </p>
  )
}

DiscountItem.propTypes = {
  isFree: PropTypes.bool,
  priceToPay: PropTypes.number,
  priceBeforeDiscount: PropTypes.string,
  currency: PropTypes.string,
  lang: PropTypes.string,
}

DiscountItem.defaultProps = {
  currency: "",
  isFree: false,
  lang: "en",
  priceToPay: 0,
  priceBeforeDiscount: "0",
}

export default DiscountItem
